module.exports = __webpack_public_path__ + "static/media/web-video.8d6c7bc1.svg";